var _rect, _path, _circle, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAudio = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "var(--asset-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7143 19.2857C18.6046 19.2857 20.1429 17.7474 20.1429 15.8571V12.4286C20.1429 10.5383 18.6046 9 16.7143 9C14.824 9 13.2857 10.5383 13.2857 12.4286V15.8571C13.2857 17.7474 14.824 19.2857 16.7143 19.2857ZM21.8571 13.5714C21.5417 13.5714 21.2857 13.8263 21.2857 14.1429V15.8571C21.2857 18.3783 19.2354 20.4286 16.7143 20.4286C14.1931 20.4286 12.1429 18.3783 12.1429 15.8571V14.1429C12.1429 13.8263 11.8869 13.5714 11.5714 13.5714C11.256 13.5714 11 13.8263 11 14.1429V15.8571C11 18.8114 13.2629 21.2217 16.1429 21.5131V23.6667H13.8889C13.5207 23.6667 13.2222 23.9651 13.2222 24.3333C13.2222 24.7015 13.5207 25 13.8889 25H16.7143H19.6667C20.0349 25 20.3333 24.7015 20.3333 24.3333C20.3333 23.9651 20.0349 23.6667 19.6667 23.6667H17.2857V21.5131C20.1657 21.2217 22.4286 18.8114 22.4286 15.8571V14.1429C22.4286 13.8263 22.1726 13.5714 21.8571 13.5714Z",
    fill: "url(#paint_audio_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 25,
    r: 4,
    fill: "url(#paint1_radial)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_audio_linear",
    x1: 11,
    y1: 9,
    x2: 11,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00838F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FB3BF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11 25) rotate(90) scale(3.81883)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5A5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1D35"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audio.8b227759.svg";
export { ForwardRef as ReactComponent };